import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';
import React from 'react';
import UDCard from 'ud-ui/components/card';
import { UDSkeletonLabel } from 'ud-ui/components/skeleton';
import UDText from 'ud-ui/components/text';
import {
  KPI_CARD_CLASS,
  KPI_GRID_CLASS,
  KPI_ICON_SIZE,
  KPI_PROGRESS_CLASS,
  KPI_PROGRESS_TRACK_CLASS,
  KPI_TOP_CLASS,
  KPI_VALUE_CLASS,
} from './kpi-layout';
import { KPI_LABELS, KPI_ORDER } from './kpi-labels';

interface KpiCardSkeletonProps {
  label: string;
  hasProgress: boolean;
}

const KpiCardSkeleton = ({ label, hasProgress }: KpiCardSkeletonProps) => (
  <UDCard radius="panel" padding="lg" className={KPI_CARD_CLASS} aria-hidden data-testid="kpi-skeleton-card">
    <UDText variant="body-1" as="div" className="!text-inkPrimary">
      {label}
    </UDText>
    <div className={KPI_TOP_CLASS}>
      <div
        className="skeleton-block shrink-0"
        style={{ width: KPI_ICON_SIZE, height: KPI_ICON_SIZE }}
        data-testid="kpi-skeleton-icon"
      />
      <UDSkeletonLabel variant="title-1" label="0000" className={KPI_VALUE_CLASS} />
    </div>
    {hasProgress && (
      <div className={KPI_PROGRESS_CLASS}>
        <div className={classNames('skeleton-block', KPI_PROGRESS_TRACK_CLASS)} data-testid="kpi-skeleton-progress" />
        <UDSkeletonLabel variant="text-2" label="00 / 00" className="self-start" />
      </div>
    )}
  </UDCard>
);

/** Скелетон сетки показателей: те же карточки `UDCard`, настоящие заголовки, плашки на месте значений. */
export const KpiGridSkeleton = () => {
  const { t } = useLingui();

  return (
    <div className={KPI_GRID_CLASS} data-testid="kpi-skeleton" aria-busy="true">
      {KPI_ORDER.map(({ key, hasProgress }) => (
        <KpiCardSkeleton key={key} label={t(KPI_LABELS[key])} hasProgress={hasProgress} />
      ))}
    </div>
  );
};
